import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import {
  List,
  ListItem,
  withStyles,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import {
  Home,
  Payment,
  LocalMall,
  ShoppingCart,
  HomeOutlined,
  PaymentOutlined,
  LocalMallOutlined,
  SupervisorAccount,
  ShoppingCartOutlined,
  SupervisorAccountOutlined,
} from '@material-ui/icons'

import { DRAWER_WIDTH, ROUTES } from '../constant'


const menu = [
  {
    icon: Home,
    fill: '#00a8ff',
    title: 'Accueil',
    pathname: ROUTES.HOME,
    iconOutlined: HomeOutlined,
  },
  {
    fill: '#e84118',
    title: 'Utilisateurs',
    pathname: ROUTES.USER,
    icon: SupervisorAccount,
    iconOutlined: SupervisorAccountOutlined,
  },
  {
    fill: '#9c88ff',
    title: 'Commerces',
    icon: LocalMall,
    pathname: ROUTES.MARKET,
    iconOutlined: LocalMallOutlined,
  },
  {
    fill: '#9b59b6',
    title: 'Commandes',
    icon: ShoppingCart,
    pathname: ROUTES.ORDER,
    iconOutlined: ShoppingCartOutlined,
  },
  {
    fill: '#009432',
    title: 'Remboursements',
    icon: Payment,
    pathname: ROUTES.REFUND,
    iconOutlined: PaymentOutlined,
  },
]


const styles = theme => ({
  root: {
    width: 0,
    flexShrink: 0,
    overflow: 'hidden',
    background: 'white',
    transition: 'width .2s ease-in-out',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
  },
  opened: {
    width: DRAWER_WIDTH,
  },
  icon: {
    opacity: 0.6,
  },
  list: {
    paddingTop: 0,
    color: theme.palette.common.black,
  },
})


const Drawer = ({
  opened,
  classes,
  pathname,
  className,
  onNavigate,
}) => {
  const handleNavigate = url => () => onNavigate(url)

  return (
    <div
      className={classNames(classes.root, {
        [classes.opened]: opened,
      }, className)}
    >
      <List className={classes.list}>
        {menu.map(item => {
          const selected = item.pathname === ROUTES.HOME ? item.pathname === pathname : pathname.includes(item.pathname)
          const iconProps = {
            style: { fill: item.fill },
            className: selected ? classes.iconSelected : classes.icon,
          }

          return (
            <ListItem
              button
              component={Link}
              key={item.pathname}
              selected={selected}
              onClick={handleNavigate(item.pathname)}
            >
              <ListItemIcon>{selected ? <item.icon {...iconProps} /> : <item.iconOutlined {...iconProps} />}</ListItemIcon>
              <ListItemText style={{ color: selected ? item.fill : 'inherit' }}>
                {item.title}
              </ListItemText>
            </ListItem>
          )
        })}
      </List>
    </div>
  )
}


Drawer.defaultProps = {
  onNavigate: () => {},
}


Drawer.propTypes = {
  opened: PropTypes.bool,
  pathname: PropTypes.string,
  onNavigate: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Drawer)
